var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rate)?_c('div',{staticClass:"flex flex-col w-[16rem] p-2 md:px-0 shadow-short border border-solid border-grey-200 rounded-1 md:border-none md:shadow-none"},[_c('Typography',{staticClass:"mb-2",attrs:{"tag":"h4","variant":"body3Light"}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('RatingIcons',{staticClass:"w-auto",attrs:{"rate":_vm.rate},scopedSlots:_vm._u([{key:"full",fn:function(ref){
var className = ref.className;
return [_c('div',{class:[
          className,
          'h-2 w-2 ml-1 inline-block rounded-[50%]',
          'bg-green-700' ]})]}},{key:"half",fn:function(ref){
        var className = ref.className;
return [_c('div',{class:[
          className,
          'h-2 w-2 ml-1 inline-block rounded-[50%]',
          'bg-green-700',
          'relative' ]},[_c('div',{staticClass:"h-2 w-1 absolute right-0 top-0 rounded-r-[50%] inline-block bg-grey-200"})])]}},{key:"empty",fn:function(className){return [_c('div',{class:[
          className,
          'h-2 w-2 ml-1 inline-block rounded-[50%]',
          'bg-grey-200' ]})]}}],null,false,350609611)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }